import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdminService {
	private readonly ADMIN_ROLE = 'view-profile';

	private userRoles: string[] = [];
	private isAdmin$ = new BehaviorSubject<boolean>(true);

	setUserRoles(roles: string[]) {
		this.userRoles = roles;
		this.isAdmin$.next(this.userRoles.includes(this.ADMIN_ROLE));
	}

	get isLoyaltyAdmin$() {
		return this.isAdmin$.asObservable();
	}
}
